import { serviceSteps } from '@/mocks/articles';

export default function ServiceIntro() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-main">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            专业干洗服务流程
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto leading-relaxed">
            从检测到交付，每一个环节都精益求精，只为给您的被芯最专业的呵护
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {serviceSteps.map((step) => (
            <div
              key={step.step}
              className="relative bg-background-50 border border-background-200/70 rounded-xl p-5 text-center group hover:border-primary-200 transition-colors duration-200"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-primary-50 text-primary-600 rounded-xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${step.icon} text-xl`}></i>
              </div>
              <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-accent-500 text-background-50 text-xs font-semibold flex items-center justify-center">
                {step.step}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 font-heading">{step.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}